"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollLock = useScrollLock;
exports.default = void 0;

var _bodyScrollLock = require("body-scroll-lock");

var _react = require("react");

function useScrollLock(htmlRef) {
  const element = htmlRef && htmlRef.current;
  (0, _react.useEffect)(() => {
    if (element) {
      (0, _bodyScrollLock.disableBodyScroll)(element);
    }

    return () => {
      if (element) {
        (0, _bodyScrollLock.enableBodyScroll)(element);
      }
    };
  }, [element]);
}

var _default = useScrollLock;
exports.default = _default;
//# sourceMappingURL=useScrollLock.js.map